import { ComponentPropsWithoutRef, forwardRef, Ref } from "react";
import { Badge } from "@/kit/ui/badge";
import { cn } from "@/utils/tailwind";

export interface VersionBadgeProps extends ComponentPropsWithoutRef<"button"> {
  version: string;
}

export default forwardRef(function VersionBadge(
  { version, type = "button", className, ...props }: VersionBadgeProps,
  ref: Ref<HTMLButtonElement>,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn("focus:outline-none", className)}
      {...props}
    >
      <Badge variant="secondary" className="cursor-pointer hover:bg-brand-50">
        v{version}
      </Badge>
    </button>
  );
});
